import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, Lock, CheckCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

const TwoFAEnforcementModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleEnableTwoFA = () => {
    navigate("/New-Dashboard/security/2fa");
  };

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 animate-fadeIn">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full animate-slideUp">
        {/* Header with Icon */}
        <div className="relative p-6 pb-4">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <ShieldAlert className="w-8 h-8 text-red-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 text-center">
              {t("twoFAEnforcement.title")}
            </h2>
          </div>
        </div>

        {/* Content */}
        <div className="px-6 pb-6">
          <p className="text-gray-600 text-center mb-6">
            {t("twoFAEnforcement.description")}
          </p>

          {/* Security Features */}
          <div className="space-y-3 mb-6">
            <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
              <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  {t("twoFAEnforcement.benefit1Title")}
                </p>
                <p className="text-xs text-gray-600">
                  {t("twoFAEnforcement.benefit1Desc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
              <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  {t("twoFAEnforcement.benefit2Title")}
                </p>
                <p className="text-xs text-gray-600">
                  {t("twoFAEnforcement.benefit2Desc")}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-blue-50 rounded-lg">
              <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm font-medium text-gray-900">
                  {t("twoFAEnforcement.benefit3Title")}
                </p>
                <p className="text-xs text-gray-600">
                  {t("twoFAEnforcement.benefit3Desc")}
                </p>
              </div>
            </div>
          </div>

          {/* Warning Message */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-6">
            <p className="text-sm text-amber-800 text-center">
              <Lock className="w-4 h-4 inline mr-1" />
              {t("twoFAEnforcement.warning")}
            </p>
          </div>

          {/* Action Button */}
          <button
            onClick={handleEnableTwoFA}
            style={{
              background: "linear-gradient(180deg, #3A5AD1 0%, #31ABFF 100%)",
            }}
            className="w-full py-3 px-4 text-white font-semibold rounded-lg hover:opacity-90 transition-opacity shadow-lg"
          >
            {t("twoFAEnforcement.enableButton")}
          </button>
        </div>
      </div>

      <style jsx>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideUp {
          from {
            transform: translateY(20px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.2s ease-out;
        }

        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>
    </div>
  );
};

export default TwoFAEnforcementModal;
